import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";

// components
import { H3 } from "core/Typography/index.js";

// styled-components
export const BatchFilterMenuStyled = styled.div`
    margin: 0px 0px ${convertPxToRem(24)} 0px;
`;

export const BatchTitleStyled = styled(H3)`
    font-size: ${convertPxToRem(23)};
    margin: ${convertPxToRem(24)} 0px;
`;
